import React from 'react';
import {
    Spinner
} from '@shopify/polaris';
import TagWorkflowCreateComponent from '../../components/TagWorkflowCreateComponent';
import TagWorkflowPreviewComponent from '../../components/TagWorkflowPreviewComponent';
import { mapToFilter } from '../../common/Helpers';
import { apiFetch } from '../../common/Helpers';

class CreateOperationComponent extends React.Component {

    state = {
        step: "create",
        loading: true,
        tags: [],
        variants: [],
        selectedOptions: [],
        smartCollections: [],
        tagOperations: [],
        operation: {
            actions: [],
            productFilters: [],
            productFiltersLogicalOperator: "And",
            description: null
        },
        preview: null
    };

    constructor(props) {
        super(props)

        if (props.operation != null) {
            this.state.operation = props.operation;
        }
    }

    render() {

        const isEdit = this.props.id != null;
        let createAction = "Preview Operation";
        let createActionHandler = this.handlePreview;

        if (this.props.skipPreview) {
            createAction = "Save Operation";
            createActionHandler = this.props.onSubmit;
        }

        return (
            <React.Fragment>
                {this.state.loading && <Spinner accessibilityLabel="Loading" size="large" color="teal" />}
                {(!this.state.loading && this.state.step === "create") && <TagWorkflowCreateComponent
                    variants={this.state.variants}
                    tags={this.state.tags}
                    smartCollections={this.state.smartCollections}
                    tagOperations={this.state.tagOperations}
                    selectedOptions={this.state.selectedOptions}
                    tagActions={this.state.operation.actions}
                    productFilters={this.state.operation.productFilters}
                    productFiltersLogicalOperator={this.state.operation.productFiltersLogicalOperator}
                    actionText={createAction}
                    onAction={createActionHandler}
                    onCancel={this.props.onCancel}
                    description={this.state.operation.description}
                    autoUpdateDescription={!isEdit}
                    showDescription={isEdit}
                    title={this.props.title} />}

                {(!this.state.loading && this.state.step === "preview") && <TagWorkflowPreviewComponent
                    preview={this.state.preview}
                    onEdit={this.handleOnEdit}
                    onSubmit={this.props.onSubmit}
                    onCreate={this.props.onCreate}
                    operation={this.state.operation} />}
            </React.Fragment>
        );
    }

    handlePreview = (operation) => {
        this.setState({
            step: "preview",
            operation: operation,
            loading: true
        });
        const mappedFilters = operation.productFilters.map(mapToFilter);
        const filter = {
            "filterType": "composite",
            "logicalOperator": operation.productFiltersLogicalOperator,
            "children": mappedFilters
        };

        apiFetch(`api/operations/tag/preview`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                actions: operation.actions,
                filter: filter,
            })
        })
            .then(response => response.json())
            .then(data => this.setState({
                loading: false,
                preview: data
            }));
    }

    handleOnEdit = async () => {
        this.setState({
            step: "create"
        })
    }

    componentDidMount() {
        apiFetch(`api/products/tagOperationData`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                variants: data.variants,
                tags: data.tags,
                selectedOptions: data.selectedOptions,
                loading: false,
                smartCollections: data.smartCollections,
                tagOperations: data.tagOperations
            }));
    }
}

CreateOperationComponent.defaultProps = {
    tags: [],
    variants: [],
    selectedOptions: [],
    operation: {
        actions: [],
        productFilters: [],
        productFiltersLogicalOperator: "And"
    },
    preview: null,
    title: "Create Tag Operation",
    id: null,
    skipPreview: false
}

export default CreateOperationComponent;